import { colors } from '@flowwai-frontend/shared/style-guide'

export const userTemplateTheme = {
   // #region - light theme config
   light: {
      userTemplateHeader: {
         closeIconColor: colors['gray-700'],
         headerTitleColor: 'text-gray-900',
         headerBorderColor: 'border-b-gray-300',
         refreshIconBg: '!bg-white'
      },
      userTemplate: {
         bodyBgColor: 'bg-gray-100'
      }
   },
   // #endregion

   // #region - dark theme config
   dark: {}
   // #endregion
}
